<template>
  <v-app id="inspire" >
    <slot />
  </v-app>
</template>